import { GenericCategory } from '../generic-category';
import { valueOrNull } from '../helpers';

import { GqlStrainType, GqlProductPotency, GqlBrand, GqlDescription } from './data.types';
import {
  GenericBrand,
  GenericStrainType,
  GenericEffect,
  GenericProductPotency,
  GenericPriceOption,
} from './generic-product.types';
import { transformStrainType, transformPotency, transformBrand } from './transformers';

type CommonProduct = {
  id: string;
  name: string;
  description?: GqlDescription;
  strainType?: GqlStrainType;
  thcContent?: GqlProductPotency;
  cbdContent?: GqlProductPotency;
  brand?: GqlBrand;
};

export abstract class GenericProduct<TData extends CommonProduct> {
  abstract readonly image: string | null;
  abstract readonly defaultImage: string;
  abstract readonly category: GenericCategory | null;
  abstract readonly effects: GenericEffect[];
  abstract readonly options: GenericPriceOption[];

  readonly rawData: TData;
  readonly id: string;
  readonly name: string;
  readonly description: string | null;
  readonly strainType: GenericStrainType | null;
  readonly thcContent: GenericProductPotency | null;
  readonly cbdContent: GenericProductPotency | null;
  readonly brand: GenericBrand | null;

  constructor(data: TData) {
    const { id, name, description, strainType, thcContent, cbdContent, brand } = data;

    this.rawData = data;

    this.id = id;
    this.name = name;
    this.description = valueOrNull(description);
    this.strainType = transformStrainType(strainType);
    this.thcContent = transformPotency(thcContent);
    this.cbdContent = transformPotency(cbdContent);
    this.brand = transformBrand(brand);
  }
}
